import { render, staticRenderFns } from "./AileanSettings.vue?vue&type=template&id=0739c7c2&scoped=true"
import script from "./AileanSettings.vue?vue&type=script&lang=ts"
export * from "./AileanSettings.vue?vue&type=script&lang=ts"
import style0 from "./AileanSettings.vue?vue&type=style&index=0&id=0739c7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0739c7c2",
  null
  
)

export default component.exports